
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-28ab4c7e&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MyAudioBook.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MyAudioBook.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-28ab4c7e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyAudioBook.vue"),
  /* scopeId */
  "data-v-28ab4c7e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/anchor/center/MyAudioBook.vue
// module id = 403
// module chunks = 0